import { filter } from 'lodash';
import Quill from 'quill/core';

const Parchment = Quill.import('parchment');
const { ClassAttributor } = Parchment;

const COMMENT_ID_LENGTH = 8;

export class CommentAttributor extends ClassAttributor {
  constructor(attrName = 'comment', keyName = 'comment') {
    super(attrName, keyName, { scope: Parchment.Scope.INLINE });
  }

  canAdd(node: HTMLElement, value: string[] | string): boolean {
    if (Array.isArray(value)) {
      return value.every((item) => this.canAdd(node, item));
    }
    return typeof value === 'string' && value.length === COMMENT_ID_LENGTH;
  }

  add(node: HTMLElement, value: string[] | string) {
    if (!this.canAdd(node, value)) return false;
    this.remove(node);
    const array = Array.isArray(value) ? value : [value];
    array.forEach((id) => {
      node.classList.add(`${this.keyName}-${id}`);
    });
    return true;
  }

  // @ts-expect-error
  value(node: HTMLElement) {
    const prefix = `${this.keyName}-`;
    const list = filter(node.classList, (c) => c.startsWith(prefix)).map(
      (c) => {
        return c.slice(prefix.length);
      },
    );
    return list.length > 0 ? list : null;
  }
}

export default new CommentAttributor();
